import InfoOutlineIcon from '@mui/icons-material/InfoOutline'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { Stack, Typography } from '@mui/material'
import { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField'
import {
  FieldInputProps,
  FieldMetaProps,
  FormikComputedProps,
  FormikHandlers,
  FormikHelpers,
  FormikRegistration,
  FormikSharedConfig,
  FormikState,
  getIn,
  useFormikContext,
} from 'formik'

interface FormikStateWithWarnings<V> extends FormikState<V> {
  warnings: Record<string, string>
}

export type FormikPropsWithWarnings<Values> = FormikSharedConfig &
  FormikStateWithWarnings<Values> &
  FormikHelpers<Values> &
  FormikHandlers &
  FormikComputedProps<Values> &
  FormikRegistration & {
    submitForm: () => Promise<any>
  }

export interface FieldPropsWithWarnings<V = any, FormValues = any> {
  field: FieldInputProps<V>
  form: FormikPropsWithWarnings<FormValues>
  meta: FieldMetaProps<V>
}

export interface TextFieldProps
  extends FieldPropsWithWarnings,
    Omit<MuiTextFieldProps, 'name' | 'value' | 'error'> {}

export const ValidationMessages = ({ fieldName }: { fieldName: string }) => {
  // @ts-ignore Still need to figure out context type with warnings
  const { touched, errors, warnings } = useFormikContext()

  const fieldError = getIn(errors, fieldName)
  const showError = getIn(touched, fieldName) && !!fieldError

  const fieldWarning = getIn(warnings, fieldName)
  const showWarning = !showError && getIn(touched, fieldName) && !!fieldWarning

  return (
    <>
      {showError && (
        <Stack direction="row" alignItems="center" spacing={0.5} mt={0.5}>
          <InfoOutlineIcon sx={{ fontSize: 14, color: 'error.main' }} />

          <Typography color="error.main" variant="caption">
            {fieldError}
          </Typography>
        </Stack>
      )}

      {showWarning && (
        <Stack direction="row" alignItems="center" spacing={0.5} mt={0.5}>
          <WarningAmberIcon sx={{ fontSize: 14, color: 'warning.main' }} />

          <Typography color="warning.main" variant="caption">
            {fieldWarning}
          </Typography>
        </Stack>
      )}
    </>
  )
}
